import * as React from 'react';
import { css } from 'aphrodite';
import styles from 'login-components/Common/svg/SVGStyles';

export default class PersonalLoanSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 100 100"
        focusable="false"
      >
        <g>
          <polygon
            className={css(styles.action)}
            points="61.015 21.763 58.558 21.763 26.188 21.763 26.188 78.237 71.076 78.237 71.076 35.768 71.076 31.823 61.015 21.763"
          />
          <rect className={css(styles.actionAccent)} x="32.793" y="27.928" width="17.508" height="4.686" rx="0.803" />
          <polygon className={css(styles.grey)} points="61.031 31.753 71.006 31.753 61.031 21.778 61.031 31.753" />
          <path
            className={css(styles.white)}
            d="M63.35,48.427H33.588a.771.771,0,1,1,0-1.541H63.35a.771.771,0,1,1,0,1.541Z"
          />
          <path
            className={css(styles.white)}
            d="M63.35,40.721H33.588a.771.771,0,1,1,0-1.541H63.35a.771.771,0,1,1,0,1.541Z"
          />
          <path
            className={css(styles.white)}
            d="M38.74,63.94H33.588a.771.771,0,1,1,0-1.542H38.74a.771.771,0,0,1,0,1.542Z"
          />
          <path
            className={css(styles.white)}
            d="M63.35,56.256H33.588a.771.771,0,0,1,0-1.542H63.35a.771.771,0,1,1,0,1.542Z"
          />
          <path
            className={css(styles.white)}
            d="M42.171,63.613a5.958,5.958,0,0,1,1.38-1.076c.315-.14.7-.206.762.183a3.576,3.576,0,0,1-.076.534,1.043,1.043,0,0,0,.938,1.117,2.958,2.958,0,0,0,2.058-.689,18.348,18.348,0,0,1,2.281-1.475,8.457,8.457,0,0,1,2.916-1.036c1.4-.114.81,1.047,1.008,1.871.418,1.738,2.387,1.146,3.4.379.39-.3.007-.965-.389-.665-.839.635-2.369,1.17-2.274-.443.037-.635.032-1.287-.567-1.67a2.529,2.529,0,0,0-2.024-.082,13.484,13.484,0,0,0-2.682,1.1c-.8.426-1.482.984-2.232,1.481-.311.206-1.091.7-1.478.456-.342-.219-.074-.816-.124-1.142-.314-2.046-2.768,0-3.442.615-.369.333.178.877.545.545Z"
          />
          <rect
            className={css(styles.actionAccent)}
            x="66.352"
            y="39.169"
            width="4.819"
            height="23.682"
            transform="translate(83.505 135.347) rotate(-136.486)"
          />
          <polygon className={css(styles.white)} points="58.861 57.938 62.356 61.256 57.747 62.627 58.861 57.938" />
          <polygon
            className={css(styles.actionAccent)}
            points="58.255 60.466 59.862 61.992 57.743 62.623 58.255 60.466"
          />
          <path
            className={css(styles.grey)}
            d="M75.557,39.786h4.819a0,0,0,0,1,0,0v.751a2.306,2.306,0,0,1-2.306,2.306h-.207a2.306,2.306,0,0,1-2.306-2.306v-.751A0,0,0,0,1,75.557,39.786Z"
            transform="translate(106.062 124.958) rotate(-136.486)"
          />
        </g>
      </svg>
    );
  }
}
